module.exports = ".width{width:100%}span{line-height:1.7;font-size:inherit}.alternate{background-color:#eff4fa}\n"